import type { ReactNode } from 'react';
import { ShowcasePanel } from './ShowcasePanel';
import { FormColumn } from './FormColumn';
import styles from './split.module.css';

/**
 * 60/40 split — showcase panel (left) + form column (right).
 * Same pattern as the Brandwik onboarding shell, adapted to Velora's palette.
 */
export function SplitShell({ children }: { children: ReactNode }) {
  return (
    <div className={styles.shell}>
      <ShowcasePanel />
      <FormColumn>{children}</FormColumn>
    </div>
  );
}
